import { render } from "./applyCostInteriorAudit.vue?vue&type=template&id=367d59c8"
import script from "./applyCostInteriorAudit.vue?vue&type=script&lang=js"
export * from "./applyCostInteriorAudit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Project\\VuePro\\ERP\\erp-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__